<template lang="pug">
.product(:style="width")
  .product__inner(ref="container")
    TransitionFade
      img.product__image(ref="img", :alt="product.alt || product.name" :src="product.image", :key="product.id")
    .product__selector
      .product__title {{ product.name }}
      select.product__select(v-model="model")
        option(
          v-for="prod in allProducts"
          :value="prod.id"
          :disabled="selections.includes(prod.id)") {{ prod.name }}
  
</template>

<script>
import TransitionFade from '../transitions/Fade.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: "AppProduct",
  props: ['product', 'index'],
  components: {
    TransitionFade
  },
  computed: {
    ...mapGetters(['allProducts', 'selections', 'width']),
    model: {
      get() {
        return this.product.id;
      },
      set(value) {
        this.updateSelection({ index: this.index, id: value });
      }
    }
  },
  methods: {
    ...mapMutations(['updateSelection']),
  }
}
</script>

<style lang="scss" scoped>
.product {
  @include cell;
  display: flex;

  &__inner {
    @include fluid(gap, 0.5rem, 0.75rem, 320px, 991px);
    display: flex;
    flex-direction: column;
    background: inherit;
    flex: 1 1 100%;
  }

  &__image {
    align-self: center;
    max-width: 100%;
    margin: auto 0;
  }

  &__selector {
    @include fluid(padding-right, 0.325rem, 0.5rem, 320px, 991px);
    @include fluid(padding-left, 0.325rem, 0.5rem, 320px, 991px);
    @include fluid(gap, 0.25rem, 0.5rem, 320px, 991px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid darken($lightGray, 20%);
    border-radius: 4px;
    height: 36px;
    background: inherit;
    position: relative;
    z-index: 0;
    position: sticky;
    z-index: 50;
    top: 0;
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(to bottom, rgba($black, 0.05), rgba($black, 0.075));
      z-index: 1;
      border-radius: 4px;
      pointer-events: none;
    }

    &::after {
      content: '';
      height: 0.325rem;
      width: 0.325rem;
      border-bottom: 1px solid $teal;
      border-right: 1px solid $teal;
      transform: translateY(-2px) rotate(45deg);
    }
  }

  &__title {
    @include fontHeadings;
    @include fluid(font-size, 0.75rem, 1.25rem, 320px, 991px);
    font-weight: 700;
    margin: 0;
    z-index: 2;
    pointer-events: none;
    white-space: nowrap;
  }

  &__select {
    appearance: none;
    border: none;
    background: none;
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
  }
}
</style>